module.exports = __webpack_public_path__ + "img/sliders.d4aabd40.svg";